<template>
  <div
    :style="{ backgroundColor: props.value }"
    :class="[
      'size-6 shrink-0',
      rounded ? 'rounded-full' : 'rounded-lg',
    ]"
  />
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{ value?: string; rounded?: boolean }>(),
  { value: undefined, rounded: false }
)
</script>
